// src/components/layout/Hero.jsx
import React from 'react';
import { Link } from 'react-router-dom';

export const Hero = () => {
  return (
    <div className="hero-container relative h-[600px] flex items-center justify-center">
      <div className="absolute inset-0">
        <img
          src="/images/IMG_1438.jpg"
          alt="Handmade wooden bowls, plates, and utensils on display"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-walnut-900/60"></div>
      </div>
      <div className="hero-content relative z-10 text-center text-linen-50">
        <h2 className="font-display text-5xl md:text-7xl font-semibold mb-6">Tree to Table</h2>
        <p className="text-xl md:text-2xl mb-8 max-w-2xl mx-auto">
          Transforming local trees into timeless pieces for your home
        </p>
        <Link
          to="/gallery"
          className="inline-block bg-copper-500 text-linen-50 px-8 py-3 rounded-lg font-medium hover:bg-copper-600 transition-colors"
        >
          Explore Our Work
        </Link>
      </div>
    </div>
  );
};